module.exports = __webpack_public_path__ + "static/img/04.87a5519.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/haeusle/04.jpg
// module id = 372
// module chunks = 1